import styled from '@emotion/styled';

const PageWrapper = styled.div`
  color: ${({ theme }) => theme.colors.white};
  height: 100vh;
  width: 100vw;
  display: grid;
  place-content: center;

  h1 {
    ${({ theme }) => theme.mixins.MonoM}
  }
`;

const NotFound = () => {
  return (
    <PageWrapper>
      <h1>404 Not Found</h1>
    </PageWrapper>
  );
};

export default NotFound;
